import requestFunctions from "../../functions/requestFunctions";

export const state = {
  IMPORTS_ITEM: {},
  IMPORTS_LIST: [],
  IMPORTS_TABLE_DATA: [],
  IMPORTS_TOTAL_ROWS: 0
}

export const getters = {
  GET_IMPORTS_ITEM: (state) => {
    return state.IMPORTS_ITEM;
  },
  GET_IMPORTS_LIST: (state) => {
    return state.IMPORTS_LIST;
  },
  GET_IMPORTS_TABLE_DATA: (state) => {
    return state.IMPORTS_TABLE_DATA;
  },
  GET_IMPORTS_TOTAL_ROWS: (state) => {
    return state.IMPORTS_TOTAL_ROWS;
  }
}

export const mutations = {
  UPDATE_IMPORTS_ITEM(state, item) {
    state.IMPORTS_ITEM = item;
  },
  UPDATE_IMPORTS_LIST(state, list) {
    state.IMPORTS_LIST = list.data;
    state.IMPORTS_TABLE_DATA = [];
    state.IMPORTS_TOTAL_ROWS = list.total;
    list = list.data;

    if(list !== null) {
      list.forEach(el => {

        let status = '';

        if(el.status === 'wait'){
          status = 'В очереди'
        }
        if(el.status === 'preparing'){
          status = 'Подготовка'
        }
        if(el.status === 'processing'){
          status = 'Обрабатывается'
        }
        if(el.status === 'error'){
          status = 'Ошибка'
        }
        if(el.status === 'finished'){
          status = 'Загружен'
        }

        let user_data = '';
    
        if(el.profile_fullname !== null){
          user_data = el.profile_fullname;
        }
        
        if(el.user_phone !== null ){
          if(user_data !== ''){
            user_data = user_data + ', ';
          }
          user_data = user_data + el.user_phone;
        }

        state.IMPORTS_TABLE_DATA.push({
          'id'        : el.id,
          'created_at': el.created_at,
          'uuid'      : el.uuid,
          'filename'  : el.filename,
          'qnt'       : el.qnt,
          'processed' : el.processed,
          'status'    : status,
          'user_data' : user_data
        });
      });
    }
  },
}

export const actions = {

  async FETCH_IMPORTS_ITEM({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/imports/'+payload.uuid;
    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_IMPORTS_ITEM', response.data);
      return response.data;
    }

  },

  async FETCH_IMPORTS_LIST({ commit }, payload = {}) {

    let query_url = 'https://api.client.za-bota.com/v1/imports';
    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_IMPORTS_LIST', response.data);
      return response.data;
    }

  },

  async FETCH_IMPORTS_CREATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/imports';
    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_IMPORTS_UPDATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/imports/'+payload.uuid;
    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_IMPORTS_DELETE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/imports/'+payload.uuid;
    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

}